function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../config-provider';
import { obj } from '../util';
import { CacheManager } from './cache-manager';
/**
 * Icon
 */

var Shell = /*#__PURE__*/function (_Component) {
  _inherits(Shell, _Component);

  var _super = _createSuper(Shell);

  function Shell() {
    _classCallCheck(this, Shell);

    return _super.apply(this, arguments);
  }

  _createClass(Shell, [{
    key: "render",
    value: function render() {
      var _cls;

      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          prefix = _this$props.prefix,
          type = _this$props.type,
          size = _this$props.size,
          className = _this$props.className,
          rtl = _this$props.rtl,
          children = _this$props.children;
      var other = obj.pickOthers(Shell.propTypes, this.props);
      var classes = cls((_cls = {}, _defineProperty(_cls, "".concat(prefix, "icon"), true), _defineProperty(_cls, "".concat(prefix, "icon-").concat(type), !!type), _defineProperty(_cls, "".concat(prefix).concat(size), !!size), _defineProperty(_cls, className, !!className), _cls));

      if (rtl && ['chevron-left', 'chevron-right', 'chevrons-left', 'chevrons-right', 'arrows-swtich-horizontal', 'arrows-swtich-vertical', 'arrows-long-down', 'arrows-long-up'].indexOf(type) !== -1) {
        other.dir = 'rtl';
      }

      return /*#__PURE__*/React.createElement("i", _extends({}, other, {
        className: classes
      }), children);
    }
  }]);

  return Shell;
}(Component);

_defineProperty(Shell, "propTypes", {
  prefix: PropTypes.string,
  rtl: PropTypes.bool,

  /**
   * 指定显示哪种图标
   */
  type: PropTypes.string,

  /**
   * 指定图标大小
   */
  size: PropTypes.oneOf(['xs', 'small', 'medium', 'large', 'xl', 'xxl', 'xxxl']),
  className: PropTypes.string
});

_defineProperty(Shell, "defaultProps", {
  prefix: 'next-',
  size: 'medium'
});

function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var Iconfont = /*#__PURE__*/function (_React$Component) {
    _inherits(Iconfont, _React$Component);

    var _super2 = _createSuper(Iconfont);

    function Iconfont(props) {
      var _this;

      _classCallCheck(this, Iconfont);

      _this = _super2.call(this, props);
      var _options$scriptUrl = options.scriptUrl,
          scriptUrl = _options$scriptUrl === void 0 ? props.scriptUrl || '//at.alicdn.com/t/font_1310450_pqkcsiccfjn.js' : _options$scriptUrl;
      /**
       * DOM API required.
       * Make sure in browser environment.
       * The Custom Icon will create a <script/>
       * that loads SVG symbols and insert the SVG Element into the document body.
       */

      if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !CacheManager.has(scriptUrl)) {
        var script = document.createElement('script');
        script.setAttribute('src', scriptUrl);
        script.setAttribute('data-namespace', scriptUrl);
        CacheManager.add(scriptUrl);
        document.body.appendChild(script);
      }

      return _this;
    }

    _createClass(Iconfont, [{
      key: "render",
      value: function render() {
        var symbolPrefix = options.symbolPrefix;

        var _this$props2 = this.props,
            type = _this$props2.type,
            children = _this$props2.children,
            restProps = _objectWithoutProperties(_this$props2, ["type", "children"]);

        var content = null;

        if (type) {
          content = /*#__PURE__*/React.createElement("use", {
            xlinkHref: "#".concat(symbolPrefix).concat(type)
          });
        }

        return /*#__PURE__*/React.createElement(Shell, _extends({
          type: type
        }, restProps, {
          className: cls(_defineProperty({}, restProps.className, !!restProps.className))
        }), /*#__PURE__*/React.createElement("svg", {
          viewBox: "0 0 1024 1024"
        }, content));
      }
    }]);

    return Iconfont;
  }(React.Component);

  _defineProperty(Iconfont, "displayName", 'Iconfont');

  return Iconfont;
}

var Icon = create({
  symbolPrefix: 'at-'
});
Icon._typeMark = 'icon';
Icon.createFromIconfont = create;
export default ConfigProvider.config(Icon);